// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay_yNyV_ .ant-popover-arrow{display:none !important}.keywordInputTooltip_cQOP_ .ant-tooltip-arrow-content{--antd-arrow-background-color: #fff}", "",{"version":3,"sources":["webpack://./src/components/dashboard/pages/keyword-rank-tracker/styles.module.scss"],"names":[],"mappings":"AACE,kCACE,uBAAA,CAKF,sDACE,mCAAA","sourcesContent":[".overlay {\r\n  :global(.ant-popover-arrow) {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.keywordInputTooltip {\r\n  :global(.ant-tooltip-arrow-content) {\r\n    --antd-arrow-background-color: #fff;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": "overlay_yNyV_",
	"antPopoverArrow": "ant-popover-arrow",
	"keywordInputTooltip": "keywordInputTooltip_cQOP_",
	"antTooltipArrowContent": "ant-tooltip-arrow-content"
};
export default ___CSS_LOADER_EXPORT___;
